import { SnackbarProvider as MuiSnackbarProvider } from 'notistack';
import { makeStyles } from '@material-ui/core';
import React from 'react';
const useStyles = makeStyles(({ palette }) => ({
    variantSuccess: {
        backgroundColor: palette.secondary.main,
    },
    variantError: {
        backgroundColor: palette.common.red,
    },
}));
export const SnackbarProvider = ({ children }) => {
    const styles = useStyles();
    return (React.createElement(MuiSnackbarProvider, { maxSnack: 5, autoHideDuration: 5000, classes: styles },
        React.createElement(React.Fragment, null, children)));
};
//# sourceMappingURL=SnackbarProvider.js.map